import { BaseComponent } from '../base-component.js';

export class AgCardTitle extends BaseComponent {
  protected styles(): string {
    return '';
  }

  protected template(): string {
    return `<div class="ag-card-title"><slot></slot></div>`;
  }
}

customElements.define('ag-card-title', AgCardTitle);
